import React from 'react';

import {
  TpHoverInfo,
  TpHoverRenderContext,
  TpHoverRenderInfo,
  ZoomPanCanvas,
} from '../../zoompan-canvas/ZoomPanCanvas';
import { TpZoomPanelInvPointMapInfo } from '../../zoompan-canvas/zoomPanCanvasHelpers';
import { TpChartProps } from '../interfaces';
import { createDefinition } from './bargraph.Renderer';
import { convertColumnDataToDisplayString } from '../../helpers/misc';
import { TpEnSelectionFilterTypes } from '../../../../data/selection/interfaces';

export function Bargraph({ chartTypeManifest, dataContext, dataBinding, config, widgetContext }: TpChartProps) {
  const widgetGlobalConfig = widgetContext.dashboardContext.widgetGlobalConfig ?? {};
  const {
    definition,
    areaPoints,
    dataTable,
    dataValue,
    dataItemId,
    nameX,
    categories,
    categoryMap,
    valueColumnInfo,
    itemCount,
    showPercentages,
    title,
  } = createDefinition(chartTypeManifest, dataContext, dataBinding, config, widgetGlobalConfig);
  const catCount = categories.length;

  function getHoverInfo(
    mappingInfo: TpZoomPanelInvPointMapInfo,
    logicPositX: number,
    logicPositY: number,
    renderPositX: number,
    renderPositY: number,
  ): TpHoverInfo | null {
    if (mappingInfo.area?.id != 'bars' && mappingInfo.area?.id != 'xaxis') return null;
    const catIdx = Math.floor(logicPositX * catCount);
    if (catIdx >= 0 && catIdx < catCount) {
      return {
        dataTableId: dataBinding.dataTableId,
        catColumnId: valueColumnInfo.id,
        itemId: categories[catIdx].value,
      };
    }
    return null;
  }

  function getHoverRenderInfo(hoverInfo: TpHoverInfo, context: TpHoverRenderContext): TpHoverRenderInfo | null {
    if (hoverInfo.dataTableId != dataBinding.dataTableId || hoverInfo.catColumnId != valueColumnInfo.id) return null;
    const cat = categoryMap[hoverInfo.itemId!];
    if (!cat) return null;
    const labels: string[] = [];
    if (context.isActiveChart) {
      labels.push(convertColumnDataToDisplayString(valueColumnInfo, cat.value));
      labels.push(`Count: ${cat.count} (${((cat.count / itemCount) * 100).toFixed(2)}%)`);
      labels.push(`Selected count: ${cat.countSelected} (${((cat.countSelected / itemCount) * 100).toFixed(2)}%)`);
    }
    return {
      area: areaPoints,
      logicPosX: (cat.positionIndex + 0.5) / catCount,
      logicPosY: showPercentages ? 100 : cat.count, // for percentage, select the top of the bar
      labels,
    };
  }

  function onItemClicked(selectedCategoryId: string) {
    widgetContext.handleUserSelectionAction({
      type: TpEnSelectionFilterTypes.CATEGORICAL,
      dataTableId: dataTable.id,
      colId: valueColumnInfo.id,
      selectedCategoryId,
    });
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ZoomPanCanvas
        definition={definition}
        getHoverInfo={getHoverInfo}
        getHoverRenderInfo={getHoverRenderInfo}
        widgetContext={widgetContext}
        onItemClicked={onItemClicked}
        maxZoomXAbsolute={catCount * 20}
        maxZoomYRelative={30}
        chartTitleInfo={{
          assetId: dataContext.assetId,
          dataType: chartTypeManifest.id,
          title,
        }}
      />
    </div>
  );
}
